import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectEndOfTreatmentTable(state),
        type: 'end-of-treatment',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryEndOfTreatment,
    changeFilter: action.changeFilterEndOfTreatment,
    toggleSort: action.toggleSortEndOfTreatment,
    toggleMultiSort: action.toggleMultiSortEndOfTreatment,
    gotoPage: action.gotoPageEndOfTreatment,
    initialColumnsVisibility: action.initialTableSettingsEndOfTreatment,
    toggleColumnVisibility: action.toggleColumnVisibilityEndOfTreatment,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/EndOfTreatmentSalesOrderSearchContainer.js